import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { ContainerVertical } from '@aftersale-next/ui';
import { Rating } from '../components/rating/rating';
import { CouponAfterDelivered } from '../components/coupon/coupon-after-delivered';
import PackagesList from '../components/packages-list/packages-list';
import PackageDetails from '../components/packages-list/package-details';
import { useTrackingMode } from '../hooks/use-app-mode';
export default function TrackingPage(_ref) {
  var order = _ref.order;

  var _useTrackingMode = useTrackingMode(),
      _useTrackingMode2 = _slicedToArray(_useTrackingMode, 1),
      trackingMode = _useTrackingMode2[0];

  var isMultiplePackages = order.packages.length > 1;
  return /*#__PURE__*/_jsxs(ContainerVertical, {
    custom: true,
    children: [/*#__PURE__*/_jsx(CouponAfterDelivered, {}), /*#__PURE__*/_jsx(Rating, {
      type: "CSAT-after-delivered"
    }), trackingMode === 'packages-list' && /*#__PURE__*/_jsx(PackagesList, {
      packages: order.packages
    }), trackingMode === 'package-details' && /*#__PURE__*/_jsx(PackageDetails, {
      isMultiplePackages: isMultiplePackages
    })]
  });
}